export const toggleSettings = (newHeaderEnabled: boolean, selector: string) => {
  const counterClassName = 'c-header-active-notification';
  const block = newHeaderEnabled
    ? (document.querySelector(`#${selector} a`) as HTMLElement)
    : document.getElementById(selector);

  return {
    counterClassName,
    block,
  };
};
